import { useCallback } from 'react';
import { useWebviewContextStore, WebviewType } from '../stores/webviewContextStore';

/**
 * 웹뷰 컨텍스트 hook 함수
 */
const useWebviewContext = () => {
    const webviewType = useWebviewContextStore((state) => state.webviewType);
    const status = useWebviewContextStore((state) => state.status);
    const initialized = useWebviewContextStore((state) => state.initialized);

    const setWebview = useWebviewContextStore((state) => state.setWebview);
    const setStatus = useWebviewContextStore((state) => state.setStatus);
    const setInitialized = useWebviewContextStore((state) => state.setInitialized);
    const resume = useWebviewContextStore((state) => state.resume);

    const isMainWebview = webviewType === 'main';

    const isIdle = status === 'idle';
    const isActive = status === 'active';
    const isInactive = status === 'inactive';

    /**
     * 웹뷰 활성화 처리
     */
    const activeWebview = useCallback(
        (param: { webviewId: string; webviewType: WebviewType }) => {
            setWebview(param);
            setStatus('active');
        },
        [setWebview, setStatus],
    );

    /**
     * 웹뷰 비활성화 처리
     */
    const inactiveWebview = useCallback(() => {
        setStatus('inactive');
    }, [setStatus]);

    const setStatusBarColor = useCallback((color: '0' | '1') => {
        useWebviewContextStore.getState().setStatusBarColor(color);
    }, []);

    const getStatusBarColor = useCallback(() => {
        return useWebviewContextStore.getState().statusBarColor;
    }, []);

    return {
        webviewType,
        status,
        initialized,

        isMainWebview,
        isIdle,
        isActive,
        isInactive,

        setInitialized,
        setStatus,
        resume,

        activeWebview,
        inactiveWebview,

        setStatusBarColor,

        getStatusBarColor,
    };
};

export default useWebviewContext;
